import { Navigate, Outlet } from "react-router";
import { useLocalStorage } from "usehooks-ts";

import { STORAGE_KEYS } from "@constants/Kiosk";
import { kioskRouteEnum } from "@enums/route.enum";
import { useLandingPageData } from "@hooks/useLandingPageData";

const KioskRedirectGuard = () => {
  const [deviceId] = useLocalStorage(STORAGE_KEYS.KIOSK_DEVICE_ID, "");
  const { data, isError, isLoading } = useLandingPageData(deviceId, {
    enabled: !!deviceId,
  });

  if (!deviceId && !isError) {
    return <Navigate to={kioskRouteEnum.Login} replace />;
  }

  if (isLoading) {
    return null;
  }

  const alreadyRedirected = sessionStorage.getItem(
    STORAGE_KEYS.LANDING_REDIRECTED
  );

  if (!alreadyRedirected && (data?.clublogoEnabled || data?.sponsorEnabled)) {
    return <Navigate to={kioskRouteEnum.Landing} replace />;
  }

  return <Outlet />;
};

export default KioskRedirectGuard;
